"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PopupContentList = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PopupContentList = exports.PopupContentList = function PopupContentList(_ref) {
  var listDefinition = _ref.listDefinition;
  var _listDefinition$separ = listDefinition.separators,
    base = _listDefinition$separ.base,
    secondLast = _listDefinition$separ.secondLast,
    last = _listDefinition$separ.last,
    style = listDefinition.style,
    type = listDefinition.type,
    listItems = listDefinition.listItems;
  var listLength = Array.isArray(listItems) ? listItems.length : Object.values(listItems).length;
  var Separator = function Separator(_ref2) {
    var index = _ref2.index;
    if (index === listLength - 1) {
      return last;
    }
    if (index === listLength - 2) {
      return secondLast;
    }
    return base;
  };
  Separator.propTypes = {
    index: _propTypes["default"].number
  };
  var ListItems = function ListItems() {
    return Array.isArray(listItems) ? listItems.map(function (listItem, index) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: listItem
      }, listItem, /*#__PURE__*/_react["default"].createElement(Separator, {
        index: index
      }));
    }) : Object.entries(listItems).map(function (_ref3, index) {
      var _ref4 = _slicedToArray(_ref3, 2),
        listItemKey = _ref4[0],
        listItemValue = _ref4[1];
      if (typeof listItemValue === 'string') {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: listItemKey
        }, listItemValue, /*#__PURE__*/_react["default"].createElement(Separator, {
          index: index
        }));
      }
      if (listItemValue.label && listItemValue.items) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: listItemKey
        }, listItemValue.label, /*#__PURE__*/_react["default"].createElement(PopupContentList, {
          listDefinition: listItemValue.items
        }));
      }
      return null;
    });
  };
  if (style === 'unordered') {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      type: type
    }, /*#__PURE__*/_react["default"].createElement(ListItems, null));
  }
  return /*#__PURE__*/_react["default"].createElement("ol", {
    type: type
  }, /*#__PURE__*/_react["default"].createElement(ListItems, null));
};
PopupContentList.propTypes = {
  listDefinition: _propTypes["default"].shape({
    separators: _propTypes["default"].shape({
      base: _propTypes["default"].string,
      secondLast: _propTypes["default"].string,
      last: _propTypes["default"].string
    }),
    style: _propTypes["default"].oneOf(['ordered', 'unordered']),
    type: _propTypes["default"].string,
    /* eslint-disable-next-line react/forbid-prop-types */
    listItems: _propTypes["default"].any
  })
};
var _default = exports["default"] = {
  PopupContentList: PopupContentList
};